import { deserialise } from "kitsu-core"

import apiClient from "api/get-client"
import call from "api/call"
import createUrl from "api/create-url"

const localDeserialize = (object) => {
  if (!object) return null
  return deserialise(object)
}

const generic = async ({
  apiEndpoint,
  apiUrlReplacements = {},
  apiData = {},
}) => {
  if (!apiEndpoint) throw new Error("apiEndpoint is required")
  if (!apiEndpoint.method) throw new Error("apiEndpoint.method is required")
  if (!apiEndpoint.url) throw new Error("apiEndpoint.url is required")

  const { method, url: urlRaw } = apiEndpoint
  let response
  try {
    const url = createUrl(urlRaw, apiUrlReplacements)
    response = await call(apiClient()[method], url, apiData)
  } catch (e) {
    if (e.name === "ServerNotReachableError") {
      // message.error("Unable to reach server, please try after some time")
      return
    }
    // message.error("An error occured, please try after some time")
    throw e
  }

  if (response && response.data && response.data.data) {
    // Handle single data deserialization
    return localDeserialize(response.data)
  }
  if (response.data.errors) {
    // Handle single data errors deserialization
    return localDeserialize(response.data)
  }

  const retval = {}
  const promises = Object.entries(response.data).map(
    async ([key, value]) => (retval[key] = await localDeserialize(value)),
  )
  await Promise.all(promises)
  return retval
}

export default generic
